"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RankingModal = void 0;
var React = __importStar(require("react"));
var reactModalHelper_1 = require("./helpers/reactModalHelper");
var react_modal_1 = __importDefault(require("react-modal"));
var modalStyle = {
    overlay: {
        zIndex: 1000,
        backgroundColor: 'rgba(51, 65, 78, .8)'
    },
    content: {
        left: '50%',
        padding: '1rem 2rem 3rem 2rem',
        right: '20%',
        top: '30%',
        bottom: '50%',
        transform: 'translate(-50%,-60%)',
        minWidth: '20rem',
        minHeight: '19rem',
    }
};
var buttonStyle = {
    fontWeight: 500,
    border: 0,
    padding: "12px",
    width: "100%",
    color: "#fff",
    backgroundColor: "#ef8201",
    display: "block",
    cursor: "pointer",
    borderRadius: "4px"
};
exports.RankingModal = function () {
    reactModalHelper_1.setReactModalAppElement();
    var _a = React.useState(true), isOpen = _a[0], setIsOpen = _a[1];
    return React.createElement(react_modal_1.default, { isOpen: isOpen, style: modalStyle, onRequestClose: function () { return setIsOpen(false); }, shouldCloseOnEsc: true },
        React.createElement("div", { className: "content" },
            React.createElement("h2", null, "Rankingen f\u00F6r 2024 sl\u00E4pps den 25 september"),
            React.createElement("p", null, "Observera att rankingen som presenteras h\u00E4r avser 2023. Klicka p\u00E5 OK f\u00F6r att forts\u00E4tta."),
            React.createElement("button", { style: buttonStyle, onClick: function () { return setIsOpen(false); } }, "OK")));
};
